import React, { useContext, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './AdminPanel.css';

const AdminPanel = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const officeAppUrl = 'http://144.91.120.120:8000/web/login';

  useEffect(() => {
    if (authLoading) return; // Aguardar autenticação terminar
    
    if (!user) {
      navigate('/admin');
      return;
    }
    if (!user.isAdmin) {
      navigate('/');
      return;
    }
  }, [user, navigate, authLoading]);

  const adminMenuItems = [
    {
      title: 'Gerenciar Usuários',
      description: 'Visualizar e gerenciar contas da área do cliente',
      icon: '👥',
      link: '/admin/usuarios',
      color: '#3498db'
    },
    {
      title: 'Gerenciar Notícias',
      description: 'Criar, editar e publicar notícias do escritório',
      icon: '📰',
      link: '/admin/noticias',
      color: '#8e44ad'
    },
    {
      title: 'Configurações do Site',
      description: 'Ajustar informações e preferências gerais do site',
      icon: '⚙️',
      link: '/admin/configuracoes',
      color: '#34495e'
    },
    {
      title: 'Mensagens Recebidas',
      description: 'Ver contatos enviados e marcar como respondidos',
      icon: '📩',
      link: '/admin/mensagens',
      color: '#16a34a'
    }
  ];

  return (
    <div className="admin-panel-page">
      <div className="admin-panel-container">
        <div className="admin-panel-header">
          <h1>PAINEL ADMINISTRATIVO</h1>
          <p className="admin-panel-subtitle">Gerencie o conteúdo e os usuários do site da advocacia</p>
        </div>

        <div className="admin-menu-grid">
          {adminMenuItems.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="admin-menu-card"
              style={{ '--card-color': item.color }}
            >
              <div className="admin-menu-icon" style={{ backgroundColor: item.color }}>
                {item.icon}
              </div>
              <div className="admin-menu-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
              <div className="admin-menu-arrow">→</div>
            </Link>
          ))}
          <a
            href={officeAppUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="admin-menu-card"
            style={{ '--card-color': '#1abc9c' }}
          >
            <div className="admin-menu-icon" style={{ backgroundColor: '#1abc9c' }}>
              🏛️
            </div>
            <div className="admin-menu-content">
              <h3>Abrir Sistema do Escritório</h3>
              <p>Abre o app interno de gestão financeira e operacional</p>
            </div>
            <div className="admin-menu-arrow">→</div>
          </a>
        </div>

        <div className="admin-panel-info">
          <div className="info-card">
            <h3>Próximos passos</h3>
            <p>Vamos evoluir este painel com os módulos da área de atendimento ao cliente.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;

